import React, { useState, useEffect } from 'react';
import { BookOpen, Star, Award, ShoppingCart, Calendar, Sparkles } from 'lucide-react';

const Reliefs: React.FC = () => {
  const [currentYear] = useState(new Date().getFullYear());
  const [selectedAppendex, setSelectedAppendex] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [previousEditions, setPreviousEditions] = useState<any[]>([]);

  useEffect(() => {
    // TODO: Charger la sélection actuelle et les éditions précédentes
    // Pour le prototype, simulation de chargement
    setTimeout(() => {
      setSelectedAppendex([]); // Vide pour l'instant
      setPreviousEditions([
        { year: 2023, status: 'published', sales: 1250 },
        { year: 2022, status: 'published', sales: 890 }
      ]);
      setIsLoading(false);
    }, 1000);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-ivory-50 to-stone-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* En-tête principal */}
        <div className="text-center mb-12 animate-fade-in">
          <div className="flex items-center justify-center space-x-3 mb-6">
            <Award className="h-12 w-12 text-amber-500" />
          </div>
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-steel mb-4">
            Reliefs
          </h1>
          <p className="text-xl text-stone max-w-4xl mx-auto leading-relaxed mb-6">
            Le guide annuel des Appendex remarquables
          </p>
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-6 max-w-2xl mx-auto">
            <div className="flex items-center justify-center space-x-2 mb-3">
              <BookOpen className="h-6 w-6 text-amber-600" />
              <span className="text-lg font-semibold text-amber-800">Édition {currentYear}</span>
            </div>
            <p className="text-amber-700 mb-4">
              Compilation des 100 conversations les plus remarquables de l'année, 
              sélectionnées par la communauté MemoMundi.
            </p>
            <div className="flex items-center justify-center space-x-4">
              <span className="text-2xl font-bold text-amber-800">29,90 €</span>
              <span className="text-sm text-amber-600">(achat séparé)</span>
            </div>
          </div>
        </div>

        {/* Section principale */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          
          {/* Sélection actuelle */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-lg shadow-lg p-8 animate-slide-up">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-bold text-steel flex items-center space-x-2">
                  <Calendar className="h-6 w-6 text-copper" />
                  <span>Sélection {currentYear}</span>
                </h2>
                <div className="bg-copper/10 text-copper-800 px-3 py-1 rounded-full text-sm font-medium">
                  En cours de compilation
                </div>
              </div>

              {isLoading ? (
                <div className="text-center py-12">
                  <div className="animate-pulse-soft">
                    <BookOpen className="h-12 w-12 text-copper mx-auto mb-4" />
                    <p className="text-steel">Compilation en cours...</p>
                  </div>
                </div>
              ) : (
                <>
                  {selectedAppendex.length === 0 ? (
                    <div className="text-center py-12">
                      <Sparkles className="h-16 w-16 text-stone mx-auto mb-4 opacity-50" />
                      <h3 className="text-lg font-semibold text-steel mb-2">
                        Sélection en cours
                      </h3>
                      <p className="text-stone mb-4">
                        Les 100 Appendex les plus remarquables de {currentYear} seront 
                        sélectionnés automatiquement en fin d'année.
                      </p>
                      <div className="bg-sky/10 p-4 rounded-lg max-w-md mx-auto">
                        <p className="text-sm text-sky-800">
                          <strong>Critères de sélection :</strong><br/>
                          • Votes de la communauté<br/>
                          • Interactions MMD Like IA™<br/>
                          • Qualité conversationnelle<br/>
                          • Impact culturel
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div className="space-y-4">
                      {/* TODO: Liste des Appendex sélectionnés */}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>

          {/* Sidebar */}
          <div className="space-y-6">
            
            {/* Commande */}
            <div className="bg-white rounded-lg shadow-lg p-6 animate-slide-up">
              <h3 className="text-lg font-semibold text-steel mb-4 flex items-center space-x-2">
                <ShoppingCart className="h-5 w-5 text-copper" />
                <span>Commander le guide</span>
              </h3>
              
              <div className="space-y-4">
                <div className="bg-gradient-to-r from-copper/10 to-amber/10 p-4 rounded-lg border border-copper/20">
                  <div className="text-center">
                    <div className="text-2xl font-bold text-steel mb-1">29,90 €</div>
                    <div className="text-sm text-stone">Guide papier premium</div>
                  </div>
                </div>
                
                <button 
                  disabled
                  className="w-full bg-stone/20 text-stone px-4 py-3 rounded-lg cursor-not-allowed flex items-center justify-center space-x-2"
                >
                  <ShoppingCart className="h-4 w-4" />
                  <span>Disponible fin {currentYear}</span>
                </button>
                
                <div className="text-xs text-stone text-center">
                  Le guide sera disponible à la commande une fois la sélection finalisée
                </div>
              </div>
            </div>

            {/* Éditions précédentes */}
            <div className="bg-white rounded-lg shadow-lg p-6 animate-slide-up">
              <h3 className="text-lg font-semibold text-steel mb-4">Éditions précédentes</h3>
              
              <div className="space-y-3">
                {previousEditions.map((edition) => (
                  <div key={edition.year} className="flex items-center justify-between p-3 bg-ivory/50 rounded-lg">
                    <div>
                      <div className="font-medium text-steel">Reliefs {edition.year}</div>
                      <div className="text-xs text-stone">{edition.sales} exemplaires vendus</div>
                    </div>
                    <div className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs">
                      {edition.status === 'published' ? 'Publié' : 'En cours'}
                    </div>
                  </div>
                ))}
              </div>
              
              {previousEditions.length === 0 && (
                <div className="text-center py-4">
                  <p className="text-sm text-stone">Première édition en préparation</p>
                </div>
              )}
            </div>

            {/* Informations */}
            <div className="bg-white rounded-lg shadow-lg p-6 animate-slide-up">
              <h3 className="text-lg font-semibold text-steel mb-4">À propos du guide</h3>
              
              <div className="space-y-3 text-sm text-steel">
                <div className="flex items-start space-x-2">
                  <div className="w-2 h-2 bg-copper rounded-full mt-2"></div>
                  <span>Format papier premium, reliure cousue</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-2 h-2 bg-copper rounded-full mt-2"></div>
                  <span>100 Appendex sélectionnés par la communauté</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-2 h-2 bg-copper rounded-full mt-2"></div>
                  <span>Achat séparé, non inclus dans les abonnements</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-2 h-2 bg-copper rounded-full mt-2"></div>
                  <span>Expédition mondiale disponible</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reliefs;